export const ITEM_HEIGHT = 48;
export const ITEM_PADDING_TOP = 8;
export const distributionDirection = ['b2b', 'b2c', 'b2cr'];
export const notificationTypes = [
  { title: 'Акции', value: 'action' },
  { title: 'Персональное', value: 'personal' },
  { title: 'Системное', value: 'system' },
];
